import React, { useEffect, useState } from 'react';
import './productDetails.css';
import ProductD from '../../assets/productD.png';
import ProductD1 from '../../assets/productD1.png';
import Veg from '../../assets/veg.png';
import DiscountLogo from '../../assets/discount-sale-svgrepo-com 2 (1).png'
import { useSwipeable } from 'react-swipeable'; 
import SimilarProducts from './similarProduct';
import Bottom from './Bottom';
/* import Procced from '../Procced/component'; */
import BackArrow from "../../../src/assets/backArrow.png"
import { useNavigate } from 'react-router-dom';
import ReplaceCard from '../../assets/ReplceCard.png'
import Procced from '../../ProccedToPay/component';
import ReplaceCartModal from '../../PopUp/ReplaceCartPopUp';
const BASE_URL = "https://daalchini.s3.ap-south-1.amazonaws.com/dcprod/"; // Replace with actual base URL if needed




const ImageCarousel1 = ({ images }) => {
  const [currentIndex, setCurrentIndex] = useState(0);

  // Handle swipe left and right using the useSwipeable hook
  const swipeHandlers = useSwipeable({
    onSwipedLeft: () => setCurrentIndex((prevIndex) => (prevIndex + 1) % images.length),
    onSwipedRight: () => setCurrentIndex((prevIndex) => (prevIndex === 0 ? images.length - 1 : prevIndex - 1)),
    trackMouse: true // Optionally allow mouse swipe for desktop testing
  });

  const nextImage = () => {
    setCurrentIndex((prevIndex) => (prevIndex + 1) % images.length);
  };

  const prevImage = () => {
    setCurrentIndex((prevIndex) =>
      prevIndex === 0 ? images.length - 1 : prevIndex - 1
    );
  };

  return (
    <div className="carousel" {...swipeHandlers}>
      {/* Image Display */}
      <img src={images[currentIndex]} alt={`Slide ${currentIndex + 1}`} />

      {/* Click Areas for Navigation */}
      <div className="nav-left" onClick={prevImage}></div>
      <div className="nav-right" onClick={nextImage}></div>

      {/* Dots Inside Image Box */}
      <div className="dots">
        {images.map((_, index) => (
          <span
            key={index}
            onClick={() => setCurrentIndex(index)}
            className={`dot ${index === currentIndex ? "active" : ""}`}
          ></span>
        ))}
      </div>
    </div>
  );
};















const ProductDetails = (props) => {

//console.log("props&&props.productDetailsData",props&&props.productDetailsData)
  const matchingData =
  props && props.cartItemsList && props.cartItemsList[0]
    ? props.cartItemsList
    : props.cartItemsList1;


    //console.log("matchingData",matchingData)


    const mergedData = props?.similarProduct?.map((item) => {
      const matchingItem = matchingData?.find(
        (matchItem) => matchItem.slotId === item.slot_id
      );
    
      //console.log("matchingItem-----", matchingItem?.count, item.mycount);
    
      return {
        ...item,
        mycount: matchingItem?.count ?? item.mycount,
      };
    }) || [];
    


//console.log("mergedData------->",mergedData)



  //console.log("tahzeeb Product Drtails------------------------>",props)
  const images = props&&props.imagePaths?.map((img) => (img.includes("http") ? img : `${BASE_URL}${img}`)) || [];
//console.log("++++++++++++++++++++++++++++++SimilarProducts",props&&props.productDetailsData&&props&&props.productDetailsData)
    const [currentIndex, setCurrentIndex] = useState(0);
    const [infoHeight, setInfoHeight] = useState("193px");
    const [expanded, setExpanded] = useState(false);
    const [infoDivHeight, setInfoDivHeight] = useState("auto");
 const navigate=useNavigate()
    useEffect(() => {
      window.scrollTo(0,0)
      handleInfo()
        //console.log('Component mounted');
        const interval = setInterval(() => {
            setCurrentIndex((prevIndex) => {
                const newIndex = (prevIndex + 1) % images.length;
                //console.log(`Image changed to index: ${newIndex}`);
                return newIndex;
            });
        }, 3000);
        
        return () => {
            //console.log('Component unmounted, clearing interval');
            clearInterval(interval);
        };
    }, []);

    const handleInfo = () => {
        setExpanded(!expanded);
        setInfoHeight(expanded ? "193px" : "auto");

        if (!expanded) {
            setTimeout(() => {
                setInfoDivHeight("auto");
            }, 500); // Wait for the main info section to expand first
        } else {
            setInfoDivHeight("auto");
        }
    };

const handleback=(e)=>{
  const machineId=localStorage.getItem("machineId")
  navigate(`/items?machineId=${machineId}&showItems=true`)



}

  

    return (
      <>
       {(props&&props.countProduct)&&<Procced   preCart={props&&props.cartItemsList[0]&&props&&props.cartItemsList}    bottom={"110px"} totalAmount={props&&props.totalAmount}  />}
       
            {props && props.replaceCard && (
        <ReplaceCartModal setReplaceCard={props.setReplceCard} replaceMyCardFun={props&&props.replaceMyCard}/>
      
      )}
   
      
{/*       {(props&&props.countProduct)?<Procced bottom={"101px"} cartCount={props&&props.countProduct} totalamount={props&&props.totalAmount}/>:""} */}

<header className="header" style={{position: "fixed",width: "100%", top: "0", zIndex: "999"}}>
              <img src={BackArrow} style={{width:"20px"}} onClick={(e)=>{handleback(e)}}/>

                <h1 style={{marginLeft:"5vw",color: "#583C43","font-size": "18px"}}>{props&&props.productDetailsData&&props&&props.productDetailsData.productName}</h1>
            
            </header>
        <div className="container-product-detail" style={{    marginTop:"20vw"}}>
           
            
     <ImageCarousel1 images={images} SimilarProducts={props&&props.SimilarProducts}/>

            <div style={{padding:"15px",    paddingBottom:"8px"}}>
            <div className="product-details">
              <div style={{ transition: "height .5s ease", height: infoHeight }}>
                <div style={{padding:"15px",    paddingBottom: "0"}}>
                <div className='product-name-div'>
                <h2 style={{fontSize:"18px",color:"#384F6F",fontWeight:"500"}}>{props&&props.productDetailsData&&props&&props.productDetailsData.productName}</h2>
                <img src={Veg} className='veg-img'/>
                </div>
                <p style={{textAlign:"start",color:"#718198",fontSize:"12px",fontWeight:"500"}}>{props&&props.productDetailsData&&props&&props.productDetailsData.product_details.packageWeight} {props&&props.productDetailsData&&props&&props.productDetailsData.product_details.quantityType}</p>
                
                </div>
                {!(props&&props.productDetailsData&&props&&props.productDetailsData.offer_details)?
                <div className="price" style={{padding:"15px"}}>
                    <span className="discount" style={{color: "#384F6F",fontSize:"14px"}}>₹{" "}{props&&props.productDetailsData&&props&&props.productDetailsData.mvOfferPrice.toFixed(2)}</span>
                  {(props&&props.productDetailsData&&props&&props.productDetailsData.activeCount)==0&&<div style={{backgroundColor:"#C71F1F",    height: "5vw",color:"white",fontWeight:"400",
    borderRadius: "1vw",
    fontSize: "10px",
    padding:"1vw",
    display:"flex",alignItems:"center",justifyContent: "center"}}>Out of stock</div>}
                    
                </div>:   

<div style={{marginTop:"5vw"}}>

                <div style={{border:"0.74px solid rgba(0, 145, 230, 1)",borderRadius:"13px",width: "130px",height: "60px",    marginLeft: "10px"                }}>
                    <img  src={DiscountLogo} style={{width:"70px",marginLeft:"85px",marginTop:"-7px"}}/>
                    <p style={{    position: "relative",
    fontSize:"10px",
       width: "68px",
    right: "-80px",
    top: "-30px",

    
    left: props.productDetailsData.offer_details.flatTypeId==1?"103px":"105px",color:"#FFFFFF",fontWeight:"500"}}>{props.productDetailsData.offer_details.flatTypeId==1&&"₹"} {props&&props.productDetailsData&&props&&props.productDetailsData.offer_details.flatAmount}{props.productDetailsData.offer_details.flatTypeId==2&&"%"} OFF</p>
                    <div style={{padding:"2vw",    position: "relative",
    top: "-46px"}}>
                    <p style={{fontSize:"10px",textAlign:"start",color:" rgba(0, 177, 119,1)",fontWeight:"500"}}>Only On App</p>
                <div className="price" style={{padding:"15px",paddingTop: 0,paddingLeft:0,paddingRight:0}}>
                    <span className="discount">₹{props&&props.productDetailsData&&props&&props.productDetailsData.mvOfferPrice.toFixed(2)}</span>
                    <span className="original">₹{props&&props.productDetailsData&&props&&props.productDetailsData.mrp.toFixed(2)}</span>
                    </div>
                    </div>
                </div>
                </div>}
                <div style={{padding:"2vw"}} onClick={(e)=>{handleInfo(e)}}>
                <div className='info-div'     style={{
                                    transition: "height 1s ease", 
                                    height: infoDivHeight
                                }}  onClick={handleInfo}>
                    <div style={{display:"flex",  
    justifyContent:"space-between",padding:"2vw",alignItems:"center"}}>
                    <h1 style={{color:"#384F6F",fontSize:"14px",color:"#384F6F", "padding-left": "3px"}}>Info</h1> <div>{!(expanded) ? <svg xmlns="http://www.w3.org/2000/svg" width="8" height="4" viewBox="0 0 8 4" fill="none">
<path d="M3.60785 3.93086C3.64821 3.97329 3.73085 4 3.82137 4C3.9119 4 3.99454 3.97329 4.0349 3.93086L7.61755 0.180882C7.63573 0.162206 7.64444 0.140769 7.64262 0.119184C7.6408 0.0975989 7.62852 0.0767968 7.60728 0.0593117C7.58366 0.0405146 7.55292 0.025339 7.51758 0.0150325C7.48225 0.00472603 7.44333 -0.000416989 7.40402 2.64227e-05H0.238729C0.15585 2.64227e-05 0.0791818 0.0224548 0.0357123 0.0593117C0.0144361 0.0767826 0.00211451 0.0975775 0.000248574 0.119163C-0.00161736 0.140748 0.00705303 0.162192 0.0252033 0.180882L3.60785 3.93086Z" fill="#384F6F"/>
</svg> : <svg xmlns="http://www.w3.org/2000/svg" width="8" height="6" viewBox="0 0 8 6" fill="none">
<path d="M3.60785 1.02521C3.64821 0.977619 3.73085 0.947652 3.82137 0.947652C3.9119 0.947652 3.99454 0.977619 4.0349 1.02521L7.61755 5.23167C7.63573 5.25262 7.64444 5.27667 7.64262 5.30088C7.6408 5.32509 7.62852 5.34843 7.60728 5.36804C7.58366 5.38912 7.55292 5.40615 7.51758 5.41771C7.48225 5.42927 7.44333 5.43504 7.40402 5.43454H0.238729C0.15585 5.43454 0.0791818 5.40938 0.0357123 5.36804C0.0144361 5.34844 0.00211451 5.32511 0.000248574 5.3009C-0.00161736 5.27669 0.00705303 5.25263 0.0252033 5.23167L3.60785 1.02521Z" fill="#384F6F"/>
</svg>}</div>
                    </div>
                    <div>
                    <div style={{display:expanded?"block":"none"}}>
                       <hr/>
                    </div>
                    <div  style={{display:expanded?"block":"none"}}>
                    <div className='detail-div' >

                    <p style={{    textAlign: "start"}} className='details-data'>Description</p>
                    <p className='details-data' style={{marginLeft:"12vw"}}>{props&&props.productDetailsData&&props&&props.productDetailsData.product_details.description} </p>
                    </div>

                    <div className='detail-div' style={{justifyContent: "flex-start"}}>
                    <p  style={{textAlign: "start"}} className='details-data'>Shelf Life</p>
                    <p className='details-data' style={{    marginLeft: "15vw", width: "50%"}}>{props&&props.productDetailsData&&props&&props.productDetailsData.product_details.shelfLife} </p>
                    </div>
                    <div className='detail-div' style={{justifyContent: "flex-start"}}>
                    <p  style={{    textAlign: "start"}} className='details-data'>Unit</p>
                    <p className='details-data'  style={{    marginLeft: "84px", width: "50%"}}>{props&&props.productDetailsData&&props&&props.productDetailsData.product_details.packageWeight}{" "}{props&&props.productDetailsData&&props&&props.productDetailsData.product_details.quantityType} </p>
                    </div>
                    <div className='detail-div'  style={{justifyContent: "flex-start"}}>
                    <p  style={{    textAlign: "start"}} className='details-data'>Hsn Code</p>
                    <p className='details-data'  style={{    marginLeft: "15vw", width: "50%"}} >{props&&props.productDetailsData&&props&&props.productDetailsData.product_details.hsnCode?props&&props.productDetailsData&&props&&props.productDetailsData.product_details.hsnCode:"------------"} </p>
                    </div>
                    <div className='detail-div'  style={{justifyContent: "flex-start"}}>
                    <p  style={{    textAlign: "start"}} className='details-data'>Quantity</p>
                    <p className='details-data'  style={{    marginLeft: "17vw", width: "50%"}}>{props&&props.productDetailsData&&props&&props.productDetailsData.product_details.quantityValue}{" "}{props&&props.productDetailsData&&props&&props.productDetailsData.product_details.unit} </p>
                    </div>

                    <div className='detail-div'  style={{justifyContent: "flex-start"}}>
                    <p  style={{    textAlign: "start"}} className='details-data'>Meal Types</p>
                    <p className='details-data'  style={{    marginLeft: "13vw", width: "50%"}}>{props&&props.productDetailsData&&props&&props.productDetailsData.product_details.mealType}</p>
                    </div>


                    <div className='detail-div'  style={{justifyContent: "flex-start"}}>
                    <p  style={{    textAlign: "start"}} className='details-data'>Brand Name</p>
                    <p className='details-data'  style={{    marginLeft: "12vw", width: "50%"}}>{props&&props.productDetailsData&&props&&props.productDetailsData.product_details.brandName}</p>
                    </div>

                    
                    <div className='detail-div'  style={{justifyContent: "flex-start"}}>
                    <p  style={{    textAlign: "start"}} className='details-data'> Microwave<br/> Heating Required</p>
                    <p className='details-data'  style={{    marginLeft: "6vw",    width: "50%"}}>{props&&props.productDetailsData&&props&&props.productDetailsData.product_details.microwaveHeatingRequired?"YES":"NO"}</p>
                    </div>

                    <div className='detail-div'  style={{justifyContent: "flex-start"}}>
                    <p  style={{    textAlign: "start"}} className='details-data'> FSSAI License</p>
                    <p className='details-data'  style={{    marginLeft: "10vw",    width: "50%"}}>{props&&props.productDetailsData&&props&&props.productDetailsData.product_details.fssaiNumber}</p>
                    </div>

                    
                   
                    </div>
                    </div>
                </div>
           </div>
            </div>
            </div>
           
            </div>
            <SimilarProducts similarProduct={mergedData} AddIntoCart={props&&props.AddIntoCart} RemovefromCart={props&&props.RemovefromCart}/>
            <Bottom props={props}/>

        </div>
        </>
    );
};

export default ProductDetails;

